import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import toast from "react-hot-toast";
import { Home, User, Calendar, LogOut, Users } from "lucide-react";

const PatientNavbar = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);
  const [fullName, setFullName] = useState("");

  useEffect(() => {
    const fetchPatientName = async () => {
      if (user) {
        const ref = doc(db, "patients_auth", user.uid);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setFullName(snap.data().fullName || "Patient");
        }
      }
    };

    fetchPatientName();
  }, [user]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success("Logged out successfully");
      navigate("/");
    } catch (err) {
      console.error("Error logging out:", err);
      toast.error("Failed to log out");
    }
  };

  if (!user) return null;

  return (
    <nav className="sticky top-0 z-50 bg-gradient-to-r from-teal-50/90 via-white/90 to-white/90 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src="/logo-green.png"
              alt="PulseNote"
              className="w-8 h-8"
            />
            <h1 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
              PulseNote
            </h1>
          </div>

          <div className="hidden md:flex items-center space-x-1">
            <button
              onClick={() => navigate("/patient/portal")}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 hover:text-teal-600 hover:bg-teal-50 transition-all text-sm font-medium"
            >
              <Home className="w-4 h-4" />
              <span>My Portal</span>
            </button>
            <button
              onClick={() => navigate("/patient/book")}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 hover:text-teal-600 hover:bg-teal-50 transition-all text-sm font-medium"
            >
              <Calendar className="w-4 h-4" />
              <span>Book Visit</span>
            </button>
            <button
              onClick={() => navigate("/patient/family-manager")}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 hover:text-teal-600 hover:bg-teal-50 transition-all text-sm font-medium"
            >
              <Users className="w-4 h-4" />
              <span>My Family</span>
            </button>

            <div className="h-6 w-px bg-gray-200 mx-3"></div>

            <button
              onClick={() => navigate("/patient/profile")}
              className="flex items-center gap-2 pl-2 pr-3 py-1.5 rounded-full hover:bg-teal-50 transition-all group border border-transparent hover:border-teal-100"
            >
              <div className="w-7 h-7 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                <User className="w-4 h-4" />
              </div>
              <span className="text-gray-700 font-semibold text-sm group-hover:text-teal-700 transition-colors">{fullName}</span>
            </button>

            <button
              onClick={handleLogout}
              className="ml-2 text-slate-400 hover:text-red-600 p-2 rounded-full hover:bg-red-50 transition-colors"
              title="Logout"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Menu */}
          <div className="md:hidden flex items-center gap-3">
            <span className="text-sm text-gray-600">{fullName}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-1.5 bg-gradient-to-r from-teal-600 to-emerald-600 text-white px-3 py-1.5 rounded-lg text-sm font-medium shadow-sm"
            >
              <LogOut className="w-3.5 h-3.5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PatientNavbar;
